import { render, staticRenderFns } from "./MeetTeamSection.vue?vue&type=template&id=420bdfb2&scoped=true&"
import script from "./MeetTeamSection.vue?vue&type=script&lang=js&"
export * from "./MeetTeamSection.vue?vue&type=script&lang=js&"
import style0 from "./MeetTeamSection.vue?vue&type=style&index=0&id=420bdfb2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420bdfb2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VCol,VRow})
